import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-chevron-right",
  templateUrl: "./med-icon-chevron-right.component.html",
})
export class MedIconChevronRightComponent extends SvgMixinComponent {}
